import { PaletteMode, Components, Theme } from '@mui/material';
import { themePalette } from '../theme.palette';
import { typographyTokens } from '../typography-tokens';
import dimensions from '../dimensions';

export const MuiListTheme = (): Components<Theme>['MuiList'] => {
  return {
    styleOverrides: {
      root: {
        padding: 0,
        // Specific styling when List is used inside Menu
        '&.MuiMenu-list': {
          padding: 0,
        },
      },
    },
  };
};

export const MuiListSubheaderTheme = (mode: PaletteMode): Components<Theme>['MuiListSubheader'] => {
  const { componentTokens } = themePalette(mode);
  const { spacing } = dimensions;

  return {
    styleOverrides: {
      root: {
        // Group header styling for Select/Autocomplete
        position: 'sticky',
        top: '-6px',
        zIndex: 1,
        backgroundColor: componentTokens.selectMenuItems.color.item.background.containerBase,
        color: componentTokens.selectMenuItems.color.item.text.row.resting,
        fontSize: typographyTokens.fontSizes.xs,
        lineHeight: typographyTokens.lineHeights.xs,
        fontWeight: typographyTokens.fontWeights.semibold,
        textTransform: 'uppercase',
        padding: spacing(3), // 12px
        letterSpacing: '0.5px',
      },
    },
  };
};

export const MuiListItemTextTheme = (): Components<Theme>['MuiListItemText'] => {
  return {
    styleOverrides: {
      root: {
        margin: 0, // Remove default margin
      },
      primary: {
        fontSize: typographyTokens.fontSizes.sm,
        lineHeight: typographyTokens.lineHeights.sm,
      },
    },
  };
};
